import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '@/config'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

import community from './modules/community'
import apartment from './modules/apartment'
import application from './modules/application'
import meeting from './modules/meeting'
import question from './modules/question'
import occupant from './modules/occupant'
import house from './modules/house'
import address from './modules/address'
import finance from './modules/finance'
import chairman from './modules/chairman'
import auth from './modules/auth'

export default new Vuex.Store({
  state: () => ({
    activeIndex: 0
  }),
  getters: {
    isLoggedIn: state => state.auth.user.isLoggedIn,
    getRequestConfig: state => {
      if (state.auth.user == null) {
        return null
      }
      return {
        headers: {
          Authorization: state.auth.user.token
        }
      }
    },
    getRequestConfigPut: state => {
      if (state.auth.user == null) {
        return null
      }
      return {
        headers: {
          Authorization: state.auth.user.token,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    },
    getRequestMultipartConfig: state => {
      if (state.auth.user == null) {
        return null
      }
      return {
        headers: {
          Authorization: state.auth.user.token,
          'Content-Type': 'multipart/mixed'
        }
      }
    },
    activeIndex: state => state.activeIndex
  },
  mutations: {
    SET_ACTIVE_INDEX: (state, payload) => {
      state.activeIndex = payload
    }
  },
  actions: {
    GET_LIST({getters}, request) {
      return new Promise((resolve, reject) => {
        axios
          .get(config.APi_URL + request.uri, {
            headers: getters.getRequestConfig.headers,
            params: request.params
          })
          .then(response => resolve(response.data))
          .catch(err => reject(err))
      })
    },
    GET_ACTIVE_INDEX({commit}, index) {
      commit('SET_ACTIVE_INDEX', index)
    }
  },
  plugins: [createPersistedState()],
  modules: {
    community,
    apartment,
    application,
    meeting,
    question,
    occupant,
    house,
    address,
    finance,
    chairman,
    auth
  }
})
